import {observer} from "mobx-react";
import React, {useContext} from "react";
import OrderSettingsPageStoreContext from "../context";

import {Button, Paper, Typography} from "../../../../../common/components/libs";
import { IikoTerminal, MenuType, ReportingDestinationType, TelegramChat } from "../../../../../services/menu/models";
import {useTranslation} from "react-i18next";


const ChatsBlock = () => {
    const {t} = useTranslation(["general", "menu"]);
    const store = useContext(OrderSettingsPageStoreContext);
    const menuType = store.menuType;

    return <>
        {menuType === MenuType.regular && <Typography variant={"h3"} mt={20}>
            {t("menu:orderSettingsPage.receivingOrdersAndWaiterCall")}
        </Typography>}
        {menuType === MenuType.booking && <Typography variant={"h3"} mt={20}>
            {t("menu:orderSettingsPage.receivingOrdersAndBookings")}
		</Typography>}
        <Typography variant={"body2"} mb={2} color={'textSecondary'}>
            {t("menu:orderSettingsPage.setUpNotificationsAboutNewOrdersInTelegram")}
        </Typography>
        {
            store.reportingDestinations
                .filter(destination => {
                    return destination.type === ReportingDestinationType.telegramChat ||
                        destination.type === ReportingDestinationType.iikoCloudTerminal
                })
                .map((destination, index) => {
                   if(destination.type === ReportingDestinationType.telegramChat){
                       const ch = destination as TelegramChat;
                       return (
                           <Paper p={5} mt={2} style={{ maxWidth: 800, width: "100%", display: "flex", justifyContent:"space-between" }}>
                               <Typography key={index} variant={'h6'}>{ch.chatTitle}</Typography>
                               <div>
                                   <Button color='primary'
                                           onClick={() => {
                                               store.openEditTelegramNotifications(destination, index);
                                           }}>
                                       {t("general:edit")}
                                   </Button>
                                   <Button color='default'
                                           onClick={ async ()=> {
                                                const destinations = store.reportingDestinations.filter(item => {
                                                   if (item.type === ReportingDestinationType.telegramChat) {
                                                       return item.chatId !== destination.chatId
                                                   }});
                                                await store.setReportingDestinations(destinations);
                                           }}>
                                       {t("general:delete")}</Button>
                               </div>
                           </Paper>
                       )
                   }else if(destination.type === ReportingDestinationType.iikoCloudTerminal){
                       const ch = destination as IikoTerminal;
                       return (
                           <Paper p={5} mt={2} style={{ maxWidth: 800, width: "100%" }}>
                               <Typography key={index} variant={'h6'}>IIko-терминал #{ch.terminalGroupId}</Typography>
                           </Paper>
                       )
                   }
                })
        }
        <Button
            color="primary"
            variant={'contained'}
            fullWidth
            mt={2}
            onClick={() => {
                store.openUpdateChatForm();
            }}
        >
            {t("menu:orderSettingsPage.addChat")}
        </Button>

    </>

}


export default observer(ChatsBlock)
